import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Collapsible from '../collapsible'
import {
  Breadcrumb,
  Button
} from 'react-bootstrap'

@observer(['globals', 'quickbooks'])
export default class Quickbooks extends Component {

  constructor(props) {
    super(props)

    this.state = {
      message: '',
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    }
  }

  getQuickbooksCompanyInfo() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    })

    this.props.quickbooks.getQuickbooksCompanyInfo((data) => {
      console.log(data)
      this.setState({
        qbCompanyInfo: JSON.stringify(data)
      })
    })
  }

  getQuickbooksCustomerInfo() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    })
    let qbCustomerId = 150

    this.props.quickbooks.getQuickbooksCustomerInfo(qbCustomerId, (data) => {
      console.log(data)
      this.setState({
        qbCustomerInfo: JSON.stringify(data)
      })
    })
  }

  getQuickbooksCompanyItems() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: '',
      qbInvoicePDF: ''
    })

    this.props.quickbooks.getQuickbooksCompanyItems((data) => {
      console.log(data)
      this.setState({
        qbItems: JSON.stringify(data)
      })
    })
  }

  getQuickbooksCompanyItem() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    })

    let itemId = 3

    this.props.quickbooks.getQuickbooksCompanyItem(itemId, (data) => {
      console.log(data)
      this.setState({
        qbItem: JSON.stringify(data)
      })
    })
  }

  getQuickbooksCompanyTerms() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    })

    this.props.quickbooks.getQuickbooksTerms((data) => {
      console.log(data)
      this.setState({
        qbTerms: JSON.stringify(data)
      })
    })
  }

  getQuickbooksCompanyTaxRates() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    })

    this.props.quickbooks.getQuickbooksTaxRates((data) => {
      console.log(data)
      this.setState({
        qbTaxRates: JSON.stringify(data)
      })
    })
  }

  getQuickbooksInvoicePDF() {
    this.setState({
      qbCompanyInfo: '',
      qbCustomerInfo: '',
      qbCreateCustomer: '',
      qbItems: '',
      qbItem: '',
      qbTerms: '',
      qbTaxRates: '',
      qbInvoicePDF: ''
    })

    let qbOrderNumber = '380'

    this.props.quickbooks.getQuickbooksInvoicePDF(qbOrderNumber, (data) => {
      console.log(data)
      this.setState({
        qbInvoicePDF: JSON.stringify(data)
      })
    })
  }

  render() {

    const quickbooksContent = (
      <div>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksCompanyInfo.bind(this) }>Get Company Info</Button></p>
        <p>{ this.state.qbCompanyInfo }</p>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksCustomerInfo.bind(this) }>Get Customer Info</Button></p>
        <p>{ this.state.qbCustomerInfo }</p>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksCompanyItems.bind(this) }>Get Company Items</Button></p>
        <p>{ this.state.qbItems }</p>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksCompanyItem.bind(this) }>Get Company Item</Button></p>
        <p>{ this.state.qbItem }</p>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksCompanyTerms.bind(this) }>Get Company Terms</Button></p>
        <p>{ this.state.qbTerms }</p>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksCompanyTaxRates.bind(this) }>Get Tax Rates</Button></p>
        <p>{ this.state.qbTaxRates }</p>
        <p><Button bsStyle="primary" onClick={ this.getQuickbooksInvoicePDF.bind(this) }>Get Invoice PDF</Button></p>
        <p>{ this.state.qbInvoicePDF }</p>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Quickbooks API Tests</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Quickbooks API Tests" content={ quickbooksContent } />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/quickbooks/quickbooks.js